import { AdditionalColumnCellProps } from "PFApp/activities/manage_roles/parts/additional_column_cell/additional_column_cell.types";
import { Stack } from "PFComponents/containers";
import { useWatch } from "react-hook-form";

import css from "../cell.module.scss";

const COOWNED_KEY = "coowned";

export const StandardAdditionalColumnCell = ({
  column,
  rolesFormKey,
  renderCell,
  info
}: AdditionalColumnCellProps) => {
  const name = `${rolesFormKey}.${info.row.index}.original.${column.name}`;
  const coownedPath = `${rolesFormKey}.${info.row.index}.original.${COOWNED_KEY}`;

  const value = useWatch({ name });
  const coowned = useWatch({ name: coownedPath });

  const row = {
    original: {
      activity: {
        [COOWNED_KEY]: coowned
      }
    }
  };

  return <Stack className={css.cell}>{renderCell(column)({ ...info, row, getValue: () => value })}</Stack>;
};
